<template>
    <div class="wrapper-box">
        <div class="option" style="flex: 20%">
            <van-dropdown-menu>
                <van-dropdown-item v-model="index" :options="list" @change="handleChange" />
            </van-dropdown-menu>
        </div>
        <div v-if="startDate && endDate" style="flex: 50%;text-align: center">
            {{startDate}}至{{endDate}}
        </div>
        <div v-else style="flex: 50%;text-align: center">
            全部
        </div>
        <div class="total" style="flex: 30%">
            <span>共：</span>
            <span>{{total}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TheSearchByDate",
        props:{
            total:{

            },
        },
        data(){
            return{
                index:1,
                list:[{
                    value:1,
                    text:'本月'
                },{
                    value:2,
                    text:'上月'
                },{
                    value:3,
                    text:'今天'
                },{
                    value:4,
                    text:'昨天'
                },{
                    value:0,
                    text:'全部'
                },{
                    value:-1,
                    text:'搜索'
                }],
                startDate:null,
                endDate:null,
            }
        },
        mounted() {
            const activeItem = parseInt(sessionStorage.getItem('active_item'));
            if(activeItem){
               this.index = activeItem;
                const startTime = sessionStorage.getItem('startDate');
                const endTime = sessionStorage.getItem('endDate');
                if(startTime && endTime){
                    this.startDate = startTime.split(' ')[0];
                    this.endDate = endTime.split(' ')[0];
                    this.$emit('handleChangeDate',startTime,endTime)
                }

            }
        },
        methods:{
            handleChange(){
                let startDate = null;
                let endDate = new Date();
                let year = endDate.getFullYear();
                let month = endDate.getMonth() + 1;
                let day = endDate.getDate();

                if(this.index === 1){// 本月
                    startDate = year + '-' + month + '-' + 0 + ' 00:00:00';
                    endDate = this.formatDate(endDate);
                }else if(this.index === 2){// 上月
                    if(month === 1){
                        year = year - 1;
                        month = 12;
                    }else{
                        month = month - 1;
                    }
                    const temp = new Date(year,month,0);
                    const day = (temp.getDate());//上个月有多少天
                    startDate = year + '-' + month + '-' + 0 + ' 00:00:00';
                    endDate = year + '-' + month + '-' + day + ' 23:59:59';
                }else if(this.index === 3){// 今天
                    startDate = year + '-' + month + '-' + day + ' 00:00:00';
                    endDate = this.formatDate(endDate);
                }else if(this.index === 4){//昨天
                    const date = new Date();
                    date.setTime(date.getTime()-24*60*60*1000);
                    startDate = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate() + ' 00:00:00';
                    endDate = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate() + ' 23:59:59';
                }else if(this.index === 0){
                    startDate = null;
                    endDate = null;
                }else if(this.index === -1){
                    this.$router.push({
                        name:'searchByDate'
                    });
                    return;
                }
                if(startDate && endDate){
                    this.startDate = startDate.split(' ')[0];
                    this.endDate = endDate.split(' ')[0];
                }else{
                    this.startDate = null;
                    this.endDate = null;
                }
                sessionStorage.setItem('t_s_s','yes')
                this.$emit('handleChangeDate',startDate,endDate)

            },

            formatDate(date){
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const hours =  date.getHours(); //获取系统时，
                const min = date.getMinutes(); //分
                const s = date.getSeconds(); //秒
                return year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + s;
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper-box{
        background: #F6F4F4!important;
        display: flex;
        align-items: center;
        padding: 10px;
        box-sizing: border-box;
        justify-content: space-between;
        .option{
            border-radius: 30px;
        }
    }
</style>
<style>
    .option .van-dropdown-menu{
        border-radius: 30px;
        height: 30px;
        line-height: 30px;
    }
    .option .van-dropdown-menu .van-dropdown-menu__item{
        height: 30px;
        line-height: 30px;
    }
</style>